<template>
<div>

<div :class="{'row':true,'card-item':true,'gray-item':v.can==false||(v.status==2||v.status==3)}" v-for="v in card" :key="v.card_id" @click="select_card(v)">
  <div class="col-4 center card-left">
     <h3>{{v.free}}</h3>
     <p><small>{{v.condition}}</small></p>
  </div>
  <div class="col-6 card-right">
    <h4>{{v.title?v.title:v.name}}</h4>
    <p><small>{{v.expire}}</small></p>
    <i class="fa fa-check card-choose" v-show="type==1&&v.card_id==cid"></i>
    <i class="fa fa-send-o card-use" v-show="type==2&&v.status==1"> 马上使用</i>
    <i class="fa fa-get-pocket card-use" v-show="type==3&&!v.isget"> 马上领取</i>
    <i class="fa fa-get-pocket card-use gray" v-show="type==3&&v.isget"> 已经领取</i>
  </div>
</div>

</div>
</template>



<style scoped>
.card-left{background:rgb(89,129,216) ;color:white;padding:.5rem;min-height:6rem;}
.card-right{padding:.3rem;}
.card-right p{padding:.5rem;}
.card-item{width:90%;margin:1rem 5%;;border:1px solid #ddd;position:relative;}
.gray-item{color:#999;border:1px solid #ddd;}
.gray-item .card-left{background:#999;}
.card-choose{font-size:2rem;color:red;position:absolute;bottom:.2rem;right:.5rem;}
.card-use{position:absolute;bottom:.2rem;right:.5rem;}
</style>


<script>
export default {
    data(){
        return {
           //now:"",
        }
    },
    props:{
        card:Array,
        type:{type:Number,default:1},
        cardid:{type:Number,default:0}
        },
    computed:{
        cid(){
            return this.cardid;
        }
    },    
    methods:{
        select_card(v){
            if(v.card_id==this.cid){this.cid=0;}else{
                  this.cid=v.card_id;
            }
            this.$emit("select",v);
        }
    }
}



</script>


// WEBPACK FOOTER //
// src/lib/card.vue